"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minLengthValidator = exports.requiredValidator = exports.yupValidator = void 0;
const isYupValidationError = (e) => {
    return e.name === "ValidationError";
};
const yupValidator = (yupSchema) => (value_1, _a) => __awaiter(void 0, [value_1, _a], void 0, function* (value, { label }) {
    try {
        yield (label ? yupSchema.label(label) : yupSchema).validate(value);
    }
    catch (e) {
        if (isYupValidationError(e)) {
            return e.message;
        }
        else {
            throw e;
        }
    }
    return null;
});
exports.yupValidator = yupValidator;
const requiredValidator = (value_2, _b) => __awaiter(void 0, [value_2, _b], void 0, function* (value, { schema, label }) {
    if (schema.required && (value == null || value === "")) {
        return { id: "validation/required", values: { label } };
    }
});
exports.requiredValidator = requiredValidator;
const minLengthValidator = (value_3, _c) => __awaiter(void 0, [value_3, _c], void 0, function* (value, { schema, label }) {
    if (schema.minLength && value && value.length < schema.minLength) {
        return {
            id: "validation/minLength",
            values: { label, minLength: schema.minLength },
        };
    }
});
exports.minLengthValidator = minLengthValidator;
